import Axios from 'axios'
import { config, axiosRetryConfig } from 'src/network/FlockjayProvider'
import axiosRetry from 'axios-retry'

const NoAuthProvider = Axios.create(config)

axiosRetry(NoAuthProvider, axiosRetryConfig)

export { NoAuthProvider }
